import React from "react";
import Particle from "../../Particle";
import { Container } from "react-bootstrap";

export default function Notfound() {
  return (
    <section className="home-section">
      <Container fluid id="home">
        <Particle />

        <Container className="home-content d-flex flex-column justify-content-center align-items-center">
          
          {/* Animation */}
          {/* <lottie-player
            src="https://assets6.lottiefiles.com/packages/lf20_zkzzfkke.json"
            background="transparent"
            speed="1"
            style={{ width: "40%", height: "100%" }}
            loop
            autoplay
          ></lottie-player> */}

          {/* Blogs Section */}
          <div style={{ marginTop: "2rem", textAlign: "center" }}>
            <h3 className="purple">Blogs</h3>

            <p style={{ marginTop: "1rem" }}>
              <a
                href="https://medium.com/@prashantmalviya272002/breaking-the-records-hackerrank-problem-b1be2bd09d9e"
                target="_blank"
                rel="noopener noreferrer"
                className="purple"
                style={{ textDecoration: "none" }}
              >
                Breaking the Records – HackerRank Problem
              </a>
            </p>

            <p>
              <a
                href="https://www.geeksforgeeks.org/connect/post/70679/coding-just-a-job-skill-or-a-tool-to-build-real-things/"
                target="_blank"
                rel="noopener noreferrer"
                className="purple"
                style={{ textDecoration: "none" }}
              >
                Coding: Just a Job Skill or a Tool to Build Real Things?
              </a>
            </p>
          </div>

        </Container>
      </Container>
    </section>
  );
}
